import { useEffect, useRef, useState } from 'react';

import { Tooltip, Typography } from '@/design-system';

export function LongText({
  text,
  lineClamp = 2,
  fontWeight = 400,
  fontSize = 16,
}: {
  text: string;
  lineClamp?: number;
  fontWeight?: number;
  fontSize?: number;
}) {
  const ref = useRef<HTMLParagraphElement>(null);
  const [overflowing, setOverflowing] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setOverflowing(el.scrollHeight > el.clientHeight + 1);

    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, [text]);

  const content = (
    <Typography
      ref={ref}
      fontWeight={fontWeight}
      style={{
        display: '-webkit-box',
        WebkitLineClamp: lineClamp,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: '100%',
        fontSize,
      }}
    >
      {text || '-'}
    </Typography>
  );

  return overflowing ? (
    <Tooltip side="top" title={text}>
      {content}
    </Tooltip>
  ) : (
    content
  );
}
